<template>
  <drop-helper :dropOptions="dropOptions"></drop-helper>
</template>

<script>
import DropHelper from '@/components/DragDrop/DropHelper';
import { mapGetters, mapState, mapActions } from 'vuex';

export default {
  components: { DropHelper },
  props: ['item', 'preventDrop'],
  data() {
    return {
      accepts: ['page', 'noteCard'],
      firstDraggedItem: null,
      idsToMove: [],
      savedDragData: null
    };
  },
  watch: {
    draggedItems: function(n, o) {
      if (n[0]) {
        //  store the value of dragged data so when drag stops we still have it to execute on
        this.firstDraggedItem = n[0];
        this.idsToMove = this.draggedData.ids;
        this.savedDragData = this.draggedData;
      }
    }
  },
  computed: {
    ...mapGetters('pages', ['selectedPageNotes']),
    ...mapState('views/context', ['selectedPageId']),
    ...mapGetters('components/dragdrop', ['dragging']),
    ...mapState('components/dragdrop', ['draggedData']),
    dropOptions() {
      return {
        accepts: this.accepts,
        zones: [
          //  handle sorting questions
          {
            id: 'sortLeft',
            show: this.isSortable && !this.isNextItem,
            style: {
              top: 0,
              left: 0,
              right: this.isPreviousItem ? 0 : '49%',
              height: 'auto',
              bottom: 0
            },
            hoverWidth: 100,
            hoverClass: 'q-dropzone-left',
            targetCursor: true,
            onDrop: () => this.moveItem(this.isSortingForward ? -1 : 0)
          },
          {
            id: 'sortRight',
            show: this.isSortable && !this.isPreviousItem && this.item.id,
            style: {
              top: 0,
              height: 'auto',
              left: this.isNextItem ? '1px' : '52%',
              right: 0,
              bottom: 0
            },
            hoverWidth: 100,
            targetCursor: true,
            hoverClass: 'q-dropzone-right',
            onDrop: () => this.moveItem(this.isSortingBack || !this.isSameSection ? 1 : 0)
          }
          // {
          //   id: 'dropNote',
          //   show: this.isDroppable,
          //   hide: this.preventDrop,
          //   style: {
          //     top: '10px',
          //     left: 0,
          //     right: 0,
          //     bottom: '10px'
          //   },
          //   hoverClass: 'q-dropzone-merge',
          //   hoverWidth: 100,
          //   zoneText: '',
          //   zoneIcon: '',
          //   zoneClass: 'zone-merge',
          //   //hoverClass: 'hover-zone-move',
          //   onDrop: () => this.moveNote()
          // }
        ]
      };
    },
    active() {
      const matchedAccepts = this.accepts.filter(value => this.draggedData.types.includes(value));
      return this.dragging && matchedAccepts.length > 0;
    },
    draggedItems() {
      if (!this.active) {
        return [];
      }
      console.log(this.draggedData);
      return this.draggedData.items;
    },
    isDragged() {
      return this.active && this.draggedData.ids.includes(this.item.id);
    },
    isSortable() {
      return this.active && !this.isDragged && this.draggedData.types.includes('page');
    },
    isSameSection() {
      return this.item.section == this.firstDraggedItem.section;
    },
    isDroppable() {
      return (
        this.active &&
        !this.isDragged &&
        this.draggedData.types.includes('noteCard') &&
        !this.isParentSection
      );
    },
    isParentSection() {
      return (
        this.draggedData.types.includes('page') &&
        this.draggedData.items &&
        this.draggedData.items[0].section == this.item.id
      );
    },
    isSortingBack() {
      return this.isSameSection && this.item.order < this.firstDraggedItem.order;
    },
    isSortingForward() {
      return this.isSameSection && this.item.order > this.firstDraggedItem.order;
    },
    isPreviousItem() {
      const firstDraggedItem = this.firstDraggedItem || {};
      return this.active && this.isSameSection && firstDraggedItem
        ? firstDraggedItem.order - 1 == this.item.order
        : false;
    },
    isNextItem() {
      const lastDraggedItem = this.draggedItems[this.draggedItems.length - 1] || {};
      return this.active && this.isSameSection && lastDraggedItem
        ? lastDraggedItem.order + 1 == this.item.order
        : false;
    }
  },
  methods: {
    ...mapActions('pages', ['movePage']),
    moveItem(offsetOrder = 0) {
      this.movePage({
        pageId: this.idsToMove[0],
        toOrder: this.item.order + offsetOrder,
        toSection: this.item.section
      });
    },
    moveNote() {
      // const noteIds = this.idsToMove;
      // const moveToPosition = Object.values(this.page.pageNotes).filter(
      //   n => n.cardId == this.item.id && !n.toDelete
      // ).length;
      // console.log('move to:', moveToPosition);
      // const pageId = this.page.id;
      // const moveFromCardId = this.firstDraggedItem.cardId;
      // const moveToCardId = this.item.id;
      // this.moveNoteById({ noteIds, moveToCardId, moveFromCardId, moveToPosition, pageId });
    }
  }
};
</script>

<style>
.q-dropzone-left {
  border-left: 3px solid #2196f3;
}

.q-dropzone-right {
  border-right: 3px solid #2196f3;
  margin-right: -3px;
}
/* .q-dropzone-merge {
  background: #2195f345;
}

.zone-merge .drop-zone-content {
  opacity: 0;
  color: #242424;
  font-weight: bold;
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.76);
  transition: 0.5s ease all;
}

.zone-merge.hover .drop-zone-content {
  opacity: 1;
  color: #242424;
  font-weight: bold;
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.76);
  transition: 0.5s ease all;
} */
</style>
